module.exports = __webpack_public_path__ + "img/img_inner_star.2be94aab.png";